(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PresentListProductDeleteController',PresentListProductDeleteController);

    PresentListProductDeleteController.$inject = ['$uibModalInstance', 'entity', 'PresentListProduct'];

    function PresentListProductDeleteController($uibModalInstance, entity, PresentListProduct) {
        var vm = this;
        vm.presentListProduct = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PresentListProduct.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
